import { config } from '../theme/gluestack-ui.config';

export const getColorForModule = (module) => {
  const colorPalette = config.tokens.moduleColorPalette;

  if (!module || !module.id) {
    return colorPalette[0];
  }

  // Hash function: sum of digits of the id
  const sum = module.id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return colorPalette[sum % colorPalette.length];
};

export default getColorForModule;
